/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { GetReviewsQuery } from '@notino/shared/definitions/types';

const ONE_ROW_SCORE = 110;
const MIN_EXPANDABLE_SCORE = 500;

const getAttributesScore = (
  attributes: NonNullable<
    NonNullable<
      NonNullable<GetReviewsQuery['reviewsAndFilters']>['data']
    >['reviews'][number]['attributes']
  >
) => {
  const pros = attributes.pros || [];
  const cons = attributes.cons || [];
  let score = 0;
  if (attributes.pros) {
    score += ONE_ROW_SCORE; // PROS title
    score += pros.reduce(
      (acc, pro) => acc + Math.max(pro.length, ONE_ROW_SCORE),
      0
    );
  }
  if (attributes.cons) {
    score += ONE_ROW_SCORE; // CONS title
    score += cons.reduce(
      (acc, con) => acc + Math.max(con.length, ONE_ROW_SCORE),
      0
    );
  }
  return score;
};

/**
 * Logic to figure out if review text should be rendered in expandable block
 * Cannot just measure html element height because of SSR
 */
export const isReviewTextExpandable = (
  item: NonNullable<
    NonNullable<GetReviewsQuery['reviewsAndFilters']>['data']
  >['reviews'][number]
) => {
  if (item.text && item.attributes) {
    return (
      item.text.length + getAttributesScore(item.attributes) >
      MIN_EXPANDABLE_SCORE
    );
  }
  if (item.attributes) {
    return getAttributesScore(item.attributes) > MIN_EXPANDABLE_SCORE;
  }
  return (item.text?.length ?? 0) > MIN_EXPANDABLE_SCORE;
};
